export default "__VITE_ASSET__DFlDiwi7__"